import React from "react";

export const FullyChecked: string = "fullychecked";
export const PartiallyChecked: string = "partiallychecked";
export const NotChecked: string = "notchecked";

export const ParentCategoryInput = ({ currentStatus, parentOnClick }) => {
  return (
    <div
      onClick={(e)=>parentOnClick(e)}
      tabIndex={0}
      onKeyUp={(e)=> {
        if(e.key === "Enter"){
            parentOnClick(e);
          }
        }
      }
      className={`coverages__parent-category-input coverages__parent-category-input--${currentStatus}`}
    >
      <div></div>
    </div>
  );
};
